var indentation_default = {
  "indentZero": "_3Xmqv",
  "indentOne": "bX5FV",
  "indentTwo": "aB4j8",
  "indentThree": "HiABr",
  "indentFour": "_4UbEO",
  "indentFive": "_0muYU",
  "indentSix": "FYdyD"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
